/**
 * A gifted session with no related booking (Traci, 28 Sep 2026): Engagement, Bridal or Anniversary, gifted for free
 * before the client knows the date. The client picks the date in their portal (the purple "Complete Your Gift
 * Session" banner): within 60 days of the gift or it expires, and at least 31 days out. Pure.
 */
export const GIFT_SESSION_TYPES = [
  { type: 'engagement', label: 'Engagement Session' },
  { type: 'bridal', label: 'Bridal Session' },
  { type: 'anniversary', label: 'Anniversary Session' }
]
export const GIFT_SESSION_HOURS = 2

/** The package a gifted session is booked as; anything unknown is an Engagement Session. */
export function giftSessionPackage(type) {
  const t = GIFT_SESSION_TYPES.find(s => s.type === String(type || '').toLowerCase()) || GIFT_SESSION_TYPES[0]
  return { type: t.type, label: t.label, hours: GIFT_SESSION_HOURS, title: `${t.label} - ${GIFT_SESSION_HOURS} Hours` }
}
